namespace Nobox.Nobox.Pages {
    export interface SendFollowUpRequest {
        TnId?: number;
        Msg?: string;
        Subject?: string;
        FrmRs?: NoBoxCRM.FormresultsRow;
    }
}
